import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c(VBtn, {
    attrs: {
      "color": _vm.colorForActivator,
      "block": "",
      "data-cy": `${_vm.dataCy}-btn`
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('Dashboards.components.twinMap.markerOptionsEditor.inputs.rule.color.label')) + "\n  ")]), _c(VMenu, {
    attrs: {
      "absolute": "",
      "position-x": _vm.menuX,
      "position-y": _vm.menuY,
      "close-on-content-click": false
    },
    model: {
      value: _vm.colorPickerMenu,
      callback: function ($$v) {
        _vm.colorPickerMenu = $$v;
      },
      expression: "colorPickerMenu"
    }
  }, [_c('core-color-picker', {
    attrs: {
      "value": _vm.value,
      "data-cy": `${_vm.dataCy}-picker`
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };